import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiddenField, ProfileIcon } from '@guryou/html-components';
import { SystemFieldError } from 'components/shared';

import SelectableCubeGrid from './SelectableCubeGrid';

const SelectableCubeGroup = ({ resources, values, error, setError, multiple = true }) => {
  const { t } = useTranslation();
  const [selectedIds, setSelectedIds] = useState(values || []);

  const toggleSelection = id => {
    if (!id) {
      return;
    }
    if (multiple) {
      setSelectedIds(prev => (prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]));
    } else {
      setSelectedIds([id]);
    }
    setError(false);
  };

  const res = resources?.slice(0, 3) || [];
  const items = res.map(user => ({ id: user.id, label: user.name, icon: <ProfileIcon /> }));

  return (
    <>
      <SelectableCubeGrid items={items} selectedIds={selectedIds} onToggle={toggleSelection} />
      {multiple ? <HiddenField name="resources" value={selectedIds} /> : <HiddenField name="resourceId" value={selectedIds[0]} />}
      {error && <SystemFieldError>{t('ONBOARD.pleaseSelectStaff')}</SystemFieldError>}
    </>
  );
};

export default SelectableCubeGroup;
